import { Component, effect, inject, input, model, output, signal } from '@angular/core';
import {
    SignaturePadComponent,
    SignaturePadOptions,
} from '../signature-pad/signature-pad.component';
import { trigger } from '@angular/animations';
import { collapseTransitionY } from '../../../shared/transitions';
import { MatButtonModule } from '@angular/material/button';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { AppSignature } from '../../../classes/app-signature';

@Component({
    selector: 'app-signature-collector',
    templateUrl: './signature-collector.component.html',
    standalone: true,
    imports: [SignaturePadComponent, MatButtonModule],
    animations: [trigger('collapseY', collapseTransitionY(200))],
})
export class SignatureCollectorComponent {
    protected readonly snackBarSvc = inject(SnackBarService);
    type = input.required<string>();
    inputSignature = model<string | null>();
    outputSignature = output<AppSignature>();
    disableSubmitButton = signal(true);
    addingSignature = signal(false);
    sigPadOptions: SignaturePadOptions = {
        canvasWidth: 500,
        canvasHeight: 100,
        backgroundColor: '#F0F0F0',
        minDistance: 1,
        penColor: 'black'
    };
    //dependent on these specific sigPadOptions
    blankSig = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfIAAABiCAYAAACrgFEnAAAFXUlEQVR4AezVAWrbQBAF0NL7HzY3aCGQQLAdW9bq78zuK7RNbEl/9o3g//34+PjnLwPvgHfAO+Ad8A70fAf+/vGHAAECBAgQaCuQLfK2TAYnQIAAAQI1BRR5zb2YigABAgQIvCSwcpG/BOAiAgQIECDQWUCRd96e2QkQIEBgewFFPuoV8BwCBAgQIDBBQJFPQBdJgAABAgRGCSjyUZLZ50gjQIAAAQKfAor8k8E/BAgQIECgp4Ai77m37NTSCBAgQKCsgCIvuxqDESBAgACB5wKK/LmRK7IC0ggQIEDggIAiP4DlUgIECBAgUE1AkVfbiHmyAtIIECDQXECRN1+g8QkQIEBgbwFFvvf+nT4rII0AAQLDBRT5cFIPJECAAAECOQFFnrOWRCArII0AgS0EFPkWa3ZIAgQIEFhVQJGvulnnIpAVkEaAwCQBRT4JXiwBAgQIEBghoMhHKHoGAQJZAWkECHwLKPJvCj8QIECAAIF+Aoq8385MTIBAVkAagdICirz0egxHgAABAgR+F1Dkv/v4lgABAlkBaQQOCijyg2AuJ0CAAAEClQQUeaVtmIUAAQJZAWkLCCjyBZboCAQIECCwr4Ai33f3Tk6AAIGsgLRLBBT5JaweSoAAAQIEMgKKPOMshQABAgSyAtukKfJtVu2gBAgQILCigCJfcavORIAAAQJZgYlpinwivmgCBAgQIHBWQJGfFXQ/AQIECBDICvxIU+Q/OPxCgAABAgR6CSjyXvsyLQECBAgQ+CFweZH/SPMLAQIECBAgMFRAkQ/l9DACBAgQIJAVWKzIs3jSCBAgQIDAbAFFPnsD8gkQIECAwAkBRX4Cz60ECBAgQGC2gCKfvQH5BAgQIEDghIAiP4GXvVUaAQIECBC4FVDktyY+IUCAAAECbQQUeZtVZQeVRoAAAQI9BBR5jz2ZkgABAgQI3BVQ5HdZfJgVkEaAAAEC7woo8nfl3EeAAAECBAoIKPICSzBCVkAaAQIEVhJQ5Ctt01kIECBAYDsBRb7dyh04KyCNAAEC1woo8mt9PZ0AAQIECFwqoMgv5fVwAlkBaQQI7CegyPfbuRMTIECAwEICinyhZToKgayANAIEKggo8gpbMAMBAgQIEHhTQJG/Cec2AgSyAtIIELgvoMjvu/iUAAECBAi0EFDkLdZkSAIEsgLSCPQRUOR9dmVSAgQIECBwI6DIb0h8QIAAgayANAJnBBT5GT33EiBAgACByQKKfPICxBMgQCArIG01AUW+2kadhwABAgS2ElDkW63bYQkQIJAVkHa9gCK/3lgCAQIECBC4TECRX0brwQQIECCQFdgzTZHvuXenJkCAAIFFBBT5Iot0DAIECBDIClRJU+RVNmEOAgQIECDwhoAifwPNLQQIECBAICvwOE2RP7bxDQECBAgQKC+gyMuvyIAECBAgQOCxwBVF/jjNNwQIECBAgMBQAUU+lNPDCBAgQIBAVqB/kWe9pBEgQIAAgVICirzUOgxDgAABAgSOCSjyY16uJkCAAAECpQQUeal1GIYAAQIECBwTUOTHvLJXSyNAgAABAk8EFPkTIF8TIECAAIHKAoq88nays0kjQIAAgYYCirzh0oxMgAABAgS+BBT5l4T/swLSCBAgQGCIgCIfwughBAgQIEBgjoAin+MuNSsgjQABAssKKPJlV+tgBAgQILCDgCLfYcvOmBWQRoAAgaCAIg9iiyJAgAABAqMFFPloUc8jkBWQRoDA5gKKfPMXwPEJECBAoLeAIu+9P9MTyApII0CgnIAiL7cSAxEgQIAAgdcFFPnrVq4kQCArII0AgRcEFPkLSC4hQIAAAQJVBf4DAAD//wg0/T8AAAAGSURBVAMAau1p3HiZcesAAAAASUVORK5CYII=';

    drawEnd(e: any) {
        this.disableSubmitButton.set(false);
    }

    btnStartSigning() {
        this.addingSignature.set(true);
        this.disableSubmitButton.set(true);
    }

    btnCancelSigning() {
        this.addingSignature.set(false);
        this.disableSubmitButton.set(true);
    }

    btnClearSignature(pad: SignaturePadComponent) {
        pad.clear();
        this.disableSubmitButton.set(true);
    }

    btnSubmitSignature(pad: SignaturePadComponent) {
        if (this.disableSubmitButton() === true) return;

        if (pad.toDataURL() === this.blankSig) {
            this.snackBarSvc.error('Signature is blank');
            return;
        }

        this.disableSubmitButton.set(true);
        this.inputSignature.set(pad.toDataURL());
        this.addingSignature.set(false);

        let output: AppSignature = {
            AppID: 0,
            Type: this.type(),
            Signature: pad.toDataURL()
        };

        this.outputSignature.emit(output);
    }
}
